export interface MyUpdatesErrorMessage {
  type: string;
  title: string;
  status: number;
  request_id: string;
}

export function isMyUpdatesErrorMessage(object: unknown): object is MyUpdatesErrorMessage { // NOSONAR
  if (!object || typeof object !== 'object') {
    return false;
  }

  const candidate = object as Record<string, unknown>;

  return (
    typeof candidate.type === 'string' &&
    typeof candidate.title === 'string' &&
    typeof candidate.status === 'number' &&
    typeof candidate.request_id === 'string'
  );
}
